import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteApplicationMutation} from '../hooks/useApplicationsQuery';
import {useApplicationsSelection} from "../hooks/useApplicationsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteApplicationMutation = useDeleteApplicationMutation();

    const {
        selection,
        handleClearSelection,
    } = useApplicationsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteApplicationMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
